import script from "./ChangeEmail.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChangeEmail.vue?vue&type=script&lang=ts&setup=true"

import "./ChangeEmail.vue?vue&type=style&index=0&id=a41bdd38&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a41bdd38"]])

export default __exports__